var num= 0;

const setBadge= (value)=>{
    num= value;
}

const getBadge= ()=>{
    return num;
}

export {setBadge,getBadge};